<template lang="pug">
.select-vendors
  select-vendor-input(
    v-if="totalVendorOptions != null"
    v-for="(item, index) in selectedVendors"
    :key="index"
    :item="item"
    :index="index"
    :selectedVendors="selectedVendors"
    :categorys="categorys"
    :disabledVendorList="disabledVendorList"
    :showUnauthorised="showUnauthorised"
    :title="title"
    :totalVendorOptions="totalVendorOptions"
    :allRanges="allRanges"
    :ignoreEvents="ignoreEvents"
  )
  template(v-if="showAddButton")
    el-row
      el-col(:span="15" :offset="4" style="text-align:left")
        el-button(
          icon="el-icon-plus"
          @click="addVendors"
          style="background:#5f99f6; color: #ffffff;border:none"
        ) {{ $t('添加供应商') }}
    el-row(v-if="showUnauthorised")
      el-col(:span="15" :offset="4")
        el-button(
          type="text"
          style="font-size: 14px; color:#3370d2"
          @click="handleAddNewVendor"
        ) ({{ $t('没有您要的供应商？新增供应商') }}>>)
</template>

<script>
import SelectVendorInput from './SelectVendorInput'
import axios from 'axios'
export default {
  components: {
    SelectVendorInput
  },
  props: {
    title: {
      type: String,
      default () {
        return ''
      }
    },
    categorys: {
      type: Array,
      default () {
        return []
      }
    },
    selectedVendors: {
      type: Array,
      default () {
        return [{
          is_storage: 1,
          struct_group_name: '',
          struct_group_id: null
        }]
      }
    },
    disabledVendorList: {
      type: Array,
      default () {
        return []
      }
    },
    showUnauthorised: {
      type: Boolean,
      default () {
        return false
      }
    },
    allRanges: {
      type: Boolean,
      default () {
        return false
      }
    },
    ignoreEvents: {
      type: Boolean,
      default () {
        return false
      }
    },
    showAddButton: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      totalVendorOptions: null
    }
  },
  mounted () {
    this.getTotalVendorList()
  },
  methods: {
    addVendors () {
      this.selectedVendors.push({
        is_storage: 1,
        struct_group_name: '',
        struct_group_id: null
      })
    },
    handleAddNewVendor () {
      this.$confirm(this.$t('即将跳转至新增供应商界面。在新增供应商界面完成供应商邀请后，可在当前页面“待入库”类型中选择该新增供应商'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          window.open('/vendor-management/new-vendor', '_blank')
        })
        .catch(() => {})
    },
    async getTotalVendorList () {
      // let hasEvents = this.categorys.some(category => { return category.category_id === 13 })
      // if (hasEvents && !this.allRanges) {
      //   url = '/management/campaign/v3/getEventCampaignVendorList'
      //   params.filter_condition = 0
      //   params.campaign_id = this.campaignId
      // }
      try {
        const [res1, res2] = await Promise.all([this.getVendorList(), this.getVendorList(2)])
        this.totalVendorOptions = res1.concat(res2)
      } catch (err) {
        throw new Error(err)
      }
    },
    getVendorList (filterCondition) {
      let params = {}
      if (filterCondition) {
        params = {
          filter_condition: filterCondition
        }
      }
      return axios.get('/admin/struct/getVendorList', {
        params: params
      })
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    }
  }
}
</script>
